//Geocode_Crime.tsx ==============================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as MainMap from "../MainMap";
import * as Settings from "../Settings";

import React from "react";

import PictureMarkerSymbol from "@arcgis/core/symbols/PictureMarkerSymbol";

const toolDiv: string = "geocoder_crime_div";
export let searchWidget: __esri.widgetsSearch;
export let searchText: string = "";

//Setters.
export function setSearchText(text: string) {
   searchText = text;
}

let expanded: boolean = false;

interface iProps {
}

//Render function.
export function Render(props: iProps) {
   //Util.logMsg("Top of GeocodeTool Render");

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
      import("@arcgis/core/widgets/Search/LocatorSearchSource").then(({ default: LocatorSearchSource }) => {
         import("@arcgis/core/widgets/Search").then(({ default: SearchWidget }) => {

            if (Settings.geocode.enabled) {
               const geocodeSources: __esri.LocatorSearchSource[] = [];

               if (Settings.geocode.address.url) {
                  const pictureMarkerSymbol = new PictureMarkerSymbol({
                     url: "Images/Flag_1.png", width: 18, height: 18, xoffset: 9, yoffset: 9,
                  });

                  const geocodeSource1 = new LocatorSearchSource({
                     url: Settings.geocode.address.url,
                     name: Settings.geocode.address.title,
                     placeholder: Settings.geocode.address.placeholder,
                     singleLineFieldName: Settings.geocode.address.singleLineFieldName,
                     resultSymbol: pictureMarkerSymbol,
                     zoomScale: 10000,
                  });
                  geocodeSources.Add(geocodeSource1);
               }

               let useWorldGeocoder: boolean = false;
               if (geocodeSources.length === 0) {
                  useWorldGeocoder = true;
               }

               searchWidget = new SearchWidget({
                  allPlaceholder: "",
                  container: toolDiv,
                  includeDefaultSources: useWorldGeocoder,
                  locationEnabled: false,
                  maxResults: 6,
                  maxSuggestions: 6,
                  popupEnabled: false,
                  searchTerm: searchText,
                  sources: geocodeSources,
                  view: MainMap.activeView,
               });

            } //end enable geocoder.
         });
      });
   }, []);

   //Styles.
   const styles: Default.iStyles = {
      geocoder: { backgroundColor: Settings.paperColor, margin: 5, zIndex: 999 },
   };

   if (Settings.geocode.enabled) {
      return (
         <div className="app-flex-row-between">
            {Settings.geocode.address.title}
            <div id={toolDiv} style={styles.geocoder}></div>
         </div>
      ); //end return.

   } else {
      return (<div />);
   }

} //end function.
